import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Intro } from "@/components/Intro";
import { Acomodacoes } from "@/components/Acomodacoes";
import { PiscinaSocial } from "@/components/PiscinaSocial";
import { Contato } from "@/components/Contato";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <Intro />
      <Acomodacoes />
      <PiscinaSocial />
      <Contato />
    </main>
  );
}
